import { render, staticRenderFns } from "./PlatformCard.vue?vue&type=template&id=ce7f10c6&"
import script from "./PlatformCard.vue?vue&type=script&lang=js&"
export * from "./PlatformCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports